import Utils from "./utils";
import autoComplete from '@tarekraafat/autocomplete.js'

/* global KmClbScriptMain */

class ListingFilters {
  constructor() {
    this.filters = document.querySelector('.js-clb-filters');

    if (!this.filters) {
      return;
    }

    this.selectors = {
      filtersForm: '.js-clb-filters',
      sortbyValue: '.js-sortby-value',
      sortbySelect: '.js-sortby-select',
      perPageValue: '.js-per-page-value',
      perPageSelect: '.js-per-page-select',
      sellerTypes: '.js-seller-types',
      customCheckbox: '.is-custom-checkbox',
      autocomplete: '.js-autocomplete',
      dropdown: '.js-filter-dropdown',
      priceRange: '.js-clb-price-range',
      priceRangeInput: '.js-clb-price-range-input',
      priceRangeProgress: '.js-clb-price-range-progress',
      selectedPriceMin: '.js-price-range-min',
      selectedPriceMax: '.js-price-range-max',
      clearButton: '.js-filters-clear-button',
    }

    this.DOM = {
      filtersForm: document.querySelector(this.selectors.filtersForm),
      sortbySelect: document.querySelector(this.selectors.sortbySelect),
      perPageSelect: document.querySelector(this.selectors.perPageSelect),
      sortbyValue: document.querySelector(this.selectors.sortbyValue),
      perPageValue: document.querySelector(this.selectors.perPageValue),
      sellerTypes: document.querySelector(this.selectors.sellerTypes),
      autocompletes: document.querySelectorAll(this.selectors.autocomplete),
      dropdownFields: document.querySelectorAll(this.selectors.dropdown),
      priceRangeInputs: document.querySelectorAll(this.selectors.priceRangeInput),
      priceRangeProgress: document.querySelector(this.selectors.priceRangeProgress),
      selectedPriceMin: document.querySelector(this.selectors.selectedPriceMin),
      selectedPriceMax: document.querySelector(this.selectors.selectedPriceMax),
      priceRange: document.querySelector(this.selectors.priceRange),
      clearButton: document.querySelector(this.selectors.clearButton),
    }

    if (!this.DOM.filtersForm) {
      return;
    }

    this.classnames = {
      loading: 'is-loading',
    }

    this.global = KmClbScriptMain;

    const { active: activeFilters, realActive, categories, categoriesLabel, regions, regionsLabel, minMaxPrice } = this.global.filters;

    this.searchData = {
      searchAll: this.global.autocomplete.searchAll,
      searchFromStart: this.global.autocomplete.searchFromStart,
      filtersActive: activeFilters,
      filtersRealActive: realActive,
      filtersUpdated: activeFilters,
      fileName: null,
      newFileName: null,
      autocompleteInstance: null,
      categoriesAll: Object.values(categories) || [],
      categoriesLabel: categoriesLabel,
      regionsAll: Object.values(regions) || [],
      regionsLabel: regionsLabel,
      minMaxPrice: minMaxPrice,
      priceGap: 1000,
      filterChanged: null,
      index: 0,
      data: {},
    };

    this.searchData.initialFileName = this.getSearchDataFileName();

    this.searchData.availableFiles = [
      'main.json',
      this.searchData.initialFileName
    ];

    this.areFiltersActive = Object.values(this.searchData.filtersUpdated).length > 0;

    if (this.searchData.searchFromStart) {
      this.areFiltersActive = true;
    }

    this.prepareUrlParams();
    this.sellerTypeHandler();
    this.sortbyHandler();
    this.perPageHandler();
    this.customCheckboxesHandler();
    this.autocompleteFieldsEvents();
    this.autocompleteUpdate();
    this.autocomplete();
    this.priceRangeHandler();
  }

  autocompleteFieldsEvents() {
    if (this.DOM.dropdownFields.length) {
      this.DOM.dropdownFields.forEach((field) => {
        const fieldName = field.getAttribute('name');

        field.addEventListener('change', (e) => {
          field.setAttribute('data-selected', e.target.value);
          //if (this.searchData.fileName === 'main.json') {
          if (this.areFiltersActive ) {
            if (this.searchData.searchAll) {
              this.updateFilters(fieldName, e.target.value);
            }

            this.updateRealFilters(fieldName, e.target.value);
          }

          if (fieldName === 'region') {
            this.fieldDisableToggle(field);
          }
          //}
        });
      });
    }

    if (this.DOM.autocompletes.length) {
      let debounce;
      this.DOM.autocompletes.forEach((field) => {
        const fieldName = field.getAttribute('name');

        field.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' && e.target.value !== '') {
            this.DOM.filtersForm.submit();
          }
        });

        field.addEventListener('input', (e) => {
          clearTimeout(debounce);

          if (this.areFiltersActive) {
            this.updateRealFilters(e.target.getAttribute('name'), e.target.value);

            if (e.target.value === '' && this.filtersHas(fieldName)) {
              this.updateFilters(fieldName, '');

              field.focus();
            }

            if (this.totalActiveFilters() === 0) {
              debounce = setTimeout(() => {
                if (this.DOM.clearButton) {
                  this.DOM.autocompletes.forEach((f) => f.setAttribute('disabled', 'disabled'));
                  this.DOM.clearButton.click();
                }
              }, 1000);
            }
          }

          if (fieldName === 'location') {
            this.fieldDisableToggle(field);
          }
        });
      });
    }
  }

  fieldDisableToggle = (field) => {
    const disableField = field.dataset.disable;
    const fieldToDisable = this.DOM.filtersForm.querySelector(`[name="${disableField}"]`);

    if (field.value) {
      fieldToDisable.setAttribute('disabled', 'disabled');
    } else {
      fieldToDisable.removeAttribute('disabled');
    }
  }

  autocompleteUpdate() {
    if (this.searchData.initialFileName === 'main.json' && !this.searchData.searchFromStart) {
      return;
    }

    this.filters.addEventListener('clbFiltersUpdated', (e) => {
      const newFileName = this.getSearchDataFileName();

      if (newFileName !== this.searchData.newFileName) {
        if (newFileName !== 'main.json' && newFileName !== this.searchData.initialFileName && !this.searchData.availableFiles.includes(newFileName)) {

          this.DOM.filtersForm.classList.add(this.classnames.loading);

          Utils.ajaxRequest('km_clb_get_live_search_data', {
            filters: JSON.stringify(this.searchData.filtersUpdated),
            fileName: newFileName,
            minMaxPrice: JSON.stringify(this.searchData.minMaxPrice),
          }).then((response) => {
            const { searchData: { name, data } } = response;
            this.searchData.data[name] = data;

            this.DOM.filtersForm.classList.remove(this.classnames.loading);
            this.searchData.availableFiles.push(newFileName);
            this.searchData.newFileName = newFileName;
            this.autocompleteReinit();
          });
          return;
        }

        this.searchData.newFileName = newFileName;
        this.autocompleteReinit();
      }
    });
  }

  autocompleteReinit() {
    if (this.searchData.autocompleteInstance) {
      this.searchData.autocompleteInstance.unInit();
      document.querySelectorAll('ul[id^="autoComplete_list_"]').forEach((ul) => ul.remove()); // remove the lists to refresh them.
    }
    this.autocomplete();
  }

  async autocompleteData(autocompleteKey) {
    const { filesUrl, mainData } = this.global.autocomplete;
    const fileName = this.getSearchDataFileName();

    //const fileUrl = `${filesUrl}/${fileName}`;

    //const response = await fetch(fileUrl);
    const data = this.searchData.data?.[fileName] || mainData

    //const data = await response.json();

    const list = data?.[autocompleteKey] || [];

    if (this.DOM.dropdownFields.length) {
      this.DOM.dropdownFields.forEach((field) => {
        //if (field.getAttribute('name') !== this.searchData.filterChanged) {
          this.updateDropdownList(field, data);
        //}
      });
    }

    let listArray = Object.values(list);

    // get only city and county from address.
    // if (autocompleteKey === 'locations') {
    //   listArray = listArray.map((item) => {
    //     const parts = item.split(', ').slice(-3, -1);

    //     return parts.join(', ');
    //   });

    //   // remove duplicates.
    //   listArray = [...new Set(listArray)];
    // }

    return listArray.sort();
  }

  updateDropdownList(field, data) {
    if (!field) {
      return;
    }

    const key = field.dataset.autocompleteKey;
    const name = field.getAttribute('name');

    const list = typeof data[key] === 'undefined' ? [] : Object.values(data[key]) || [];
    const allKey = `${key}All`;
    const labelKey = `${key}Label`;
    const allValues = this.searchData[allKey] || [];
    const label = this.searchData[labelKey] || '';
    const activeFilter = this.searchData.filtersActive[name];

    if (!list.includes(activeFilter)) {
      list.push(activeFilter);
    }

    let updatedList = this.searchData.fileName === 'main.json' ? allValues : list.filter(value => allValues.includes(value));

    updatedList = this.prepareDropdownList(updatedList, name, allValues);

    let options = `<option value="">${label}</option>`;

    if (updatedList.length) {
      updatedList.forEach(value => {
        let selected = this.filtersHas(name) && this.searchData.filtersUpdated?.[name] === value ? 'selected' : '';

        if (!selected) {
          selected = field.dataset?.selected === value ? 'selected' : '';
        }
        options += `<option value="${value}" ${selected}>${value}</option>`;
      });
    }

    field.innerHTML = options;
  }

  prepareDropdownList = (list, filterName, allValues) => {
    const totalActiveFilters = this.totalActiveFilters();

    if (totalActiveFilters === 1 && this.searchData.filtersRealActive?.[filterName]) {
      return allValues;
    }

    return list;
  }

  autocomplete() {
    if (!this.DOM.autocompletes.length) {
      return;
    }


    this.DOM.autocompletes.forEach((autocomplete) => {
      const field = autocomplete;
      const { autocompleteKey } = field.dataset;
      // const fieldId = field.getAttribute('id');
      // const fullId = `${fieldId.replace(/_[0-9]$/g, '')}_${this.searchData.index+=1}`;
      // field.setAttribute('id', fullId);

      this.searchData.autocompleteInstance = new autoComplete({
        selector: `#${field.getAttribute('id')}`,
        placeHolder: field.getAttribute('placeholder') || '',
        data: {
          // src: async () => {
          //   return await this.autocompleteData(autocompleteKey);
          // },
          src: this.autocompleteData(autocompleteKey),
        },
        threshold: 3,
        resultItem: {
            highlight: true,
        },
        resultsList: {
          maxResults: 20,
        }
      });

      field.addEventListener('selection', (e) => {
        e.target.value = e.detail.selection.value;
        this.searchData.autocompleteInstance.close();
      })
    });
  }

  prepareUrlParams() {
    let params = new URLSearchParams(window.location.search);

    let newParams = {};

    Array.from(params.entries()).forEach((entry) => {
      const value = entry[1].trim();
      const name = entry[0].trim();

      if (value && name.indexOf('select') === -1) {
        if ( ! newParams[name] ) {
          newParams[name] = value;
        } else {
          newParams[name] += `,${value}`;
        }
      }
    });

    // create search params from newParams object
    const newSearchParams = new URLSearchParams(newParams);
    const searchParamsList = newSearchParams.toString();

    if (searchParamsList) {
      const newUrl = window.location.pathname + '?' + newSearchParams.toString();
      window.history.replaceState({ path: newUrl }, '', newUrl);
    }
  }

  sellerTypeHandler() {
    if (!this.DOM.sellerTypes) {
      return;
    }

    const inputs = this.DOM.sellerTypes.querySelectorAll('input');

    inputs.forEach((input) => {
      input.addEventListener('change', e => {
        const { value, checked } = e.target;

        let checkedInputs = Array.from(this.DOM.sellerTypes.querySelectorAll('input:checked'));
        let checkedValues = checkedInputs.map((input) => input.value);
        const uncheckedInputs = Array.from(this.DOM.sellerTypes.querySelectorAll('input:not(:checked)'));

        if (value === 'all') {
          const uncheckedInputsOther = uncheckedInputs.filter((input) => input.value !== 'all');

          if (checked) {
            if (uncheckedInputsOther.length) {
              uncheckedInputsOther.forEach((input) => input.checked = true);
            }
          } else {
            if (checkedInputs.length) {
              checkedInputs.forEach((input) => input.checked = false);
            }
          }
        } else {
          if (checked) {
            if (checkedValues.length === 3 && !checkedValues.includes('all')) {
              uncheckedInputs.every((input) => {
                if (input.value === 'all') {
                  input.checked = true;
                  return false;
                }

                return true;
              });
            }
          } else {
            if (checkedValues.includes('all')) {
              checkedInputs.every((input) => {
                if (input.value === 'all') {
                  input.checked = false;
                  return false;
                }

                return true;
              });
            }
          }
        }

        checkedInputs = Array.from(this.DOM.sellerTypes.querySelectorAll('input:checked'));
        checkedValues = checkedInputs.map((input) => input.value);

        if (this.areFiltersActive && this.searchData.searchAll) {
          this.updateFilters('seller', checkedValues);
        }
      });
    });
  }

  sortbyHandler() {
    if (!this.DOM.sortbySelect) {
      return;
    }

    this.DOM.sortbySelect.addEventListener('change', (e) => {
      if (this.DOM.sortbyValue) {
        this.DOM.sortbyValue.value = e.target.value;
      }
      this.DOM.filtersForm.submit();
    });
  }

  perPageHandler() {
    if (!this.DOM.perPageSelect) {
      return;
    }

    this.DOM.perPageSelect.addEventListener('change', (e) => {
      if (this.DOM.perPageValue) {
        this.DOM.perPageValue.value = e.target.value;
      }
      this.DOM.filtersForm.submit();
    });
  }

  customCheckboxesHandler() {
    this.DOM.customCheckboxes = this.DOM.filtersForm.querySelectorAll(this.selectors.customCheckbox);

    if (!this.DOM.customCheckboxes) {
      return;
    }

    this.DOM.customCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', () => {
        checkbox.value = checkbox.checked ? 'yes' : '';
      });
    });
  }

  priceRangeHandler() {
    if (!this.DOM.priceRangeInputs.length) {
      return;
    }

    const rangeValueUpdate = (input) => {
      const minVal = parseInt(this.DOM.priceRangeInputs[0].value);
      const maxVal = parseInt(this.DOM.priceRangeInputs[1].value);

      if (maxVal - minVal < this.searchData.priceGap) {
        if (input.className === 'is-range-min') {
          this.DOM.priceRangeInputs[0].value = maxVal - this.searchData.priceGap;
        } else {
          this.DOM.priceRangeInputs[1].value = minVal + this.searchData.priceGap;
        }
      } else {
        this.DOM.selectedPriceMin.textContent = Utils.numberFormat(minVal);
        this.DOM.selectedPriceMax.textContent = Utils.numberFormat(maxVal);
        this.DOM.priceRangeProgress.style.left = (minVal / this.DOM.priceRangeInputs[0].max) * 100 + "%";
        this.DOM.priceRangeProgress.style.right = 100 - (maxVal / this.DOM.priceRangeInputs[1].max) * 100 + "%";
      }

      const value = `${minVal}-${maxVal}`;
      this.DOM.priceRange.value = value;
    }

    this.DOM.priceRangeInputs.forEach((input) => {
      rangeValueUpdate(input);
      input.addEventListener('input', (e) => {
        rangeValueUpdate(e.target);
      });

      if (this.areFiltersActive && this.searchData.searchAll) {
        input.addEventListener('pointerup', (e) => {
          this.updateFilters('price-range', this.DOM.priceRange.value);
        });
      }
    });
  }

  getSearchDataFileName() {
    if ( ! this.searchData.filtersUpdated ) {
      return 'main.json';
    }

    // It must be in the same order in php.
    const availableFilters = [
        'category',
        'keyword',
        'region',
        'location',
        'price-range',
    ];

    let fileName = '';

    availableFilters.forEach(filter => {
      const filterValue = this.searchData.filtersUpdated?.[filter] || '';

      if (filterValue) {
        if (filter === 'price-range') {
          const priceRanges = filterValue.split('-');

          if (parseFloat(priceRanges[1]) < parseFloat(this.searchData.minMaxPrice.max) || parseFloat(priceRanges[0]) > parseFloat(this.searchData.minMaxPrice.min)) {
            if (this.searchData.searchAll) {
              fileName += `${filter}-${filterValue}-`;
            } else {
              fileName += `${filter}-`;
            }
          }
        } else if (filter === 'category') {
          if (this.searchData.searchAll) {
            fileName += `${filter}-${filterValue.replace(/\s/g, '-').toLowerCase()}-`;
          } else {
            fileName += `${filter}-`;
          }
        } else if (filter === 'region') {
          const regionValue = filterValue.replace(/\s/g, '-').toLowerCase();

          //if (regionValue !== 'national') {
            if (this.searchData.searchAll) {
              fileName += `${filter}-${regionValue}-`;
            } else {
              fileName += `${filter}-`;
            }
          //}
        } else {
          fileName += `${filter}-`;
        }
      }
    });

    if (this.searchData.filtersUpdated.seller && ((this.searchData.filtersUpdated.seller.length === 1 && !this.searchData.filtersUpdated.seller.includes('all')) || this.searchData.filtersUpdated.seller.length === 2)) {
      if (this.searchData.searchAll) {
        fileName += `seller-${this.searchData.filtersUpdated.seller.join('-')}-`;
      } else {
        fileName += 'seller-';
      }
    }

    if (fileName.length) {
      fileName = fileName.slice(0, -1);
    } else {
      fileName = 'main';
    }

    fileName += '.json';

    this.searchData.fileName = fileName;

    return fileName;
  }

  updateRealFilters = (filter, value) => {
    if (value) {
      this.searchData.filtersRealActive[filter] = value;
    } else {
      delete this.searchData.filtersRealActive[filter];
    }
  }

  updateFilters = (filter, value) => {
    this.searchData.filtersUpdated[filter] = value;
    this.searchData.filterChanged = filter;

    const event = new CustomEvent('clbFiltersUpdated', {
      detail: {
        filters: this.searchData.filtersUpdated,
        filter,
      },
    });

    this.filters.dispatchEvent(event);
  }

  filtersHas = (key) => {
    const value = this.searchData.filtersUpdated?.[key] || '';

    return value !== '';
  }

  totalActiveFilters = () => {
    return Object.values(this.searchData.filtersRealActive).length;
  }
}

export default ListingFilters;
